import script from "./ModeratorRequests.vue?vue&type=script&setup=true&lang=js"
export * from "./ModeratorRequests.vue?vue&type=script&setup=true&lang=js"

import "./ModeratorRequests.vue?vue&type=style&index=0&id=3384c05c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3384c05c"]])

export default __exports__